import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import * as React from 'react';
import { programsStore } from '../../../ProgramsStore';
import { completedProgramResource, visibleProgramResource } from '../../../ProgramsStore/Functions';
import ProgramDashboards from '../ProgramDashboard/ProgramDashboards';
import NoProgramsInTab from '../ProgramTabs/NoProgramsInTab';
import * as style from '../style.module.css';

const CompletedPrograms: React.FC<{}> = () => {
  return (
    <div className={style.active} data-test-completed-programs={true}>
      {programsStore.resource
        .map(({ payload }) =>
          payload.programs.filter(completedProgramResource).filter(visibleProgramResource),
        )
        .andThen(fromArrayMaybe)
        .map((completedPrograms) => <ProgramDashboards programs={completedPrograms} />)
        .getOrElse(() => (
          <NoProgramsInTab kind="You have no graduated programs" />
        ))}
    </div>
  );
};

export default observer(CompletedPrograms);
